module.exports = __webpack_public_path__ + "static/media/medal.7d7c9a99.svg";